import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { EmailConfirmationForm } from 'components';

export const ConfirmEmailPage = () => {
	const [searchParams] = useSearchParams();
	const email = searchParams.get('email');
	const token = searchParams.get('token');
	return <EmailConfirmationForm token={token} email={email} />;
};